module.exports = __webpack_public_path__ + "img/baike-icon.47643a0a.png";